import React from 'react'
import styels from './HomeThird.module.css'
import { Link } from 'react-router-dom'
import bgVide from '../../asssists/dancevideo1.mp4'
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import {ScrollTrigger} from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
export default function HomeThird() {
  let target = useRef();
  let container = useRef();

  useGSAP(() => {
    const tl = gsap.timeline();
    tl.to(target.current, {
      opacity: 1,
      y: 0,
      scrollTrigger: {
        trigger: "#start",
        start: "top 120px",
        toggleActions: "play play none restart",
        scrub: 1,
      }

    })
  },{scope:container})




  return (
    <>
     <section className={styels.HomeThird}> 
     <div ref={container} className="container">
     <div className="row">
     <div className={styels.box}>
     <video controls="nodownload" controlsList="nodownload" src={bgVide} autoPlay muted loop className={styels.vid}></video>
     <div className={styels.info}>
     <h2 className='mb-5 pb-5 text-white'>WANT TO KNOW MORE ABOUT OUR SERVICES</h2>
     <h4><i className="fa-solid fa-dragon fa-3x text-info"></i></h4>
     <Link to={'/projects'} className='btn btn-info p-5 fs-4 text-white'>Let's See What We Hide</Link>
     </div>
     </div>
    
     </div>
     </div>
     </section> 
    </>
  )
}
